import { IAnimBrushManager, IAnimBrushServiceDelegates } from '@src/slide/application/service/anim-brush/core/interface';
import { IDynamicServiceConfig } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

type TGetAnimBrushManagerDynamicConfig = (
    services: IAnimBrushServiceDelegates
) => IDynamicServiceConfig<IAnimBrushManager>;

export const getAnimBrushManagerDynamicConfig: TGetAnimBrushManagerDynamicConfig = services =>
    (
        {
            name: 'anim-brush-manager',
            loadType: 'eager',
            async module() {
                const AnimBrushManager = (await import('@src/slide/application/service/anim-brush/core')).default;
                return new AnimBrushManager(services);
            },
        }
    ) ;
